module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAAP0lEQVQ4y2P4jwQ+MAww7wADDNgPAh4zxF2DgccPYgwW3h8IMRh40MgaLDxwtA0W3v//SKE0sLzBkqcHT1kHAOE70ncrd5YbAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTE2VDE2OjE0OjUwKzA5OjAw3svGEgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyMiswOTowMD+oKM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00012_100x100.png
// module id = CZ+J
// module chunks = 0